<section [ngClass]="{ section: true }">
   <div class="header">
      <p
         *ngIf="title"
         class="title">
         {{ title }}
      </p>
   </div>

   <ng-content></ng-content>

   <app-loader-component
      [isLoaded]="!loading"
      [loaderType]="'SECTION_LOADER'"></app-loader-component>
</section>
